import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ApplicationService } from '../../../lib/services/application.service';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-portale-layout-footer',
    templateUrl: './portale-layout-footer.component.html',
    styleUrls: ['./portale-layout-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RouterLink]
})
export class PortaleLayoutFooterComponent implements OnInit {
  protected applicationService = inject(ApplicationService);


  applicationName: string
  isNextComunica: boolean

  constructor() {
    const applicationService = this.applicationService;

    this.applicationName = applicationService.getApplicationName()
    this.isNextComunica = applicationService.isNextComunica()
  }

  ngOnInit(): void {
  }

}
